import Document from "src/decidim/collaborative_texts/document";
import Toc from "src/decidim/collaborative_texts/toc";
window.CollaborativeTextsDocuments = window.CollaborativeTextsDocuments || {};
window.CollaborativeTextsToc = window.CollaborativeTextsToc || {};
document.addEventListener("turbo:load", () => {
  const documents = window.document.querySelectorAll("[data-collaborative-texts-document]");
  const tableOfContents = window.document.querySelectorAll("[data-collaborative-texts-toc]");
  documents.forEach((doc) => {
    let document2 = new Document(doc);
    document2.fetchSuggestions();
    if (document2.active) {
      document2.enableSuggestions();
    }
    window.CollaborativeTextsDocuments[doc.id] = document2;
  });
  tableOfContents.forEach((tocEl) => {
    let document2 = window.CollaborativeTextsDocuments[tocEl.dataset.collaborativeTextsToc];
    if (document2) {
      let toc = new Toc(tocEl, document2.doc);
      toc.render();
      window.CollaborativeTextsToc[tocEl.id] = toc;
    }
  });
});
